import React, { useState, useEffect } from 'react'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import usePageSEO from '../../hooks/usePageSEO'
import axios from "axios";
import { Link } from 'react-router-dom'
import Loader from '../../components/Loader'

const Minds = () => {
  const [loading, setLoading] = useState(true);
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const siteUrl = process.env.REACT_APP_BACKEND_URL;
  const [mindBehindWidget, setMindBehindWidget] = useState()
  const [metaTitle, setMetaTitle] = useState('')
  const [metaDescription, setMetaDescription] = useState('')
  const [boardData, setBoardData] = useState([])
  const [coreData, setCoreData] = useState([])

  const apiUrl = apiBaseUrl+`aboutpage`;



  const fetchPagedata = async() => {
    try{
    return await axios.get(apiUrl).then((res) => {
      setMetaTitle(res.data.page.meta_title);
      setMetaDescription(res.data.page.meta_description);
      setMindBehindWidget(res.data.mindwidget)
      setBoardData(res.data.boardmembers)
      setCoreData(res.data.coremembers)
    });
    }catch(err){
      console.log(err);
    }
  };  

  useEffect(() => {
    setTimeout(() => {
      fetchPagedata()
        setLoading(false);
    }, 2000);
  }, []);

  usePageSEO({
    title: `${metaTitle}`,
    description: `${metaDescription}`
  })  


  return (
    <>
    <Header/>
    
    { loading && (<Loader />)}

    <div id="⁠minds1" className="container vertical-gap"><hr /></div>  

    <section className="section-content-block minds">
      <div className="container">

        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 text-center minds">                       
            <div className="about-us-intro solution">
              <p className="blue">{mindBehindWidget?.name}</p>
              <h2 className="heading">{mindBehindWidget?.heading}</h2>
              <p className='col-lg-offset-2 col-lg-8 col-sm-12'>{mindBehindWidget?.description}</p>
            </div>                            
          </div> 
        </div>
          
        <div className="row">
          <div className="col-sm-12 text-center">
            <h3>The Board</h3>
          </div>
          {boardData.map((item, index) => {
            return ( 
              <div key={index} className="col-lg-3 col-md-4 col-sm-12">                       
                <div className="Products">
                  <img src={`${siteUrl}${item.image}`} alt={item.member_name} /> 
                  <h4 className="heading">{item.member_name}</h4>
                  <p>{item?.designation}</p>
                  <Link 
                  to={item?.linkedin} 
                  target='_blank'
                  className="custom-social-icom"
                  ><i className="fa fa-linkedin-square"></i></Link>            
                </div>

              </div>
            )
          })}
        </div>
                
        <div className="row">
          <div className="col-sm-12 text-center">
            <h3>Core personnel</h3>
          </div>

    
          {coreData.map((item, index) => {
            return ( 
              <div key={index} className="col-lg-3 col-md-4 col-sm-12">                       
                <div className="Products">
                  <img src={`${siteUrl}${item.image}`} alt={item.member_name} /> 
                  <h4 className="heading">{item.member_name}</h4>
                  <p>{item?.designation}</p>
                  <Link 
                  to={item?.linkedin} 
                  target='_blank'
                  className="custom-social-icom"
                  ><i className="fa fa-linkedin-square"></i></Link>            
                </div>

              </div>
            )
          })}



        </div>

      </div> 

    </section>

    <Footer/>
    </>
  )
}

export default Minds